import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { errorOperations } from "../../state/features/error";
import {
  addItemToCart,
  removeItemWithCartId,
  updateItemWithCartIdInCart,
} from "../../helpers/cartFunctions";
import CartItem from "../cartItem";
import { useIntl } from "react-intl";
import { RootState } from "../../state/store";
import { cartOperations } from "../../state/features/cart";
import { checkItemIsActionItem } from "../../features/promotions/helpers/utils";
import { deepCopyFunction } from "../../helpers/utils";

interface ICartItemsItemsProps {
  cartItems: any[];
  cartType?: string;
}

const CartItems = (props: ICartItemsItemsProps) => {
  let { cart } = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const { activePromotions } = useSelector((state: RootState) => state.promotions);

  const intl = useIntl();

  const incrementCount = (item: any) => {
    const shouldItemBeDuplicated = checkItemIsActionItem(
      item,
      activePromotions,
    );
    if (shouldItemBeDuplicated) {
      const itemCopy = deepCopyFunction(item);
      itemCopy.count = 1;
      addItemToCart(itemCopy, cart.items, (cartItems: any) =>
        dispatch(cartOperations.setCart(cartItems)),
      );
    } else {
      item.count = item.count + 1;
      updateItemWithCartIdInCart(item, cart.items, (cartItems: any) =>
        dispatch(cartOperations.setCart(cartItems)),
      );
    }
  };

  const decrementCount = (item: any) => {
    item.count = item.count - 1;
    updateItemWithCartIdInCart(item, cart.items, (cartItems: any) =>
      dispatch(cartOperations.setCart(cartItems))
    );
  };

  const removeItem = (item: any) => {
    removeItemWithCartId(item, cart.items, (cartItems: any) =>
      dispatch(cartOperations.setCart(cartItems))
    );
  };

  const showCartModifyError = () => {
    dispatch(
      errorOperations.updateError({
        message: intl.formatMessage({id: "message.cannot_update_order"}),
      })
    );
  };

  return (
    <>
      {props.cartItems.map((cartItem: any) => {
        return (
          <div key={cartItem.cart_id}>
            <CartItem
              cartItem={cartItem}
              cartType={props.cartType}
              incrementCount={incrementCount}
              decrementCount={decrementCount}
              removeItem={removeItem}
              showCartModifyError={showCartModifyError}
            />
          </div>
        );
      })}
    </>
  );
};

export default CartItems;
